function getEnv(envKey: 'STRIPE_ENV'): 'test' | 'live'
function getEnv(envKey: 'USER_DEV'): boolean
function getEnv(envKey: 'STRIPE_APIKEY'): string
function getEnv(envKey: 'BUILD_ENV'): string
function getEnv(envKey: 'PRODUCTION'): boolean
function getEnv(envKey: 'DEVELOPMENT'): boolean
function getEnv(envKey: 'API_BASE_URL'): string
function getEnv(envKey: 'FIREBASE_apiKey'): string
function getEnv(envKey: 'FIREBASE_authDomain'): string
function getEnv(envKey: 'FIREBASE_databaseURL'): string
function getEnv(envKey: 'FIREBASE_projectId'): string
function getEnv(envKey: 'FIREBASE_storageBucket'): string
function getEnv(envKey: 'FIREBASE_messagingSenderId'): string
function getEnv(envKey: 'FIREBASE_appId'): string
function getEnv(envKey: 'FIREBASE_measurementId'): string
function getEnv(envKey: 'FACEBOOK_PIXEL_ID'): string
function getEnv(envKey: 'GOOGLE_MAP_API_KEY'): string
function getEnv(envKey) {
  if (envKey === 'STRIPE_ENV') {
    return (process.env.NEXT_PUBLIC_STRIPE_APIKEY || '')?.indexOf('pk_test_') > -1
      ? ('test' as const)
      : ('live' as const)
  }
  if (envKey === 'STRIPE_APIKEY') {
    return process.env.NEXT_PUBLIC_STRIPE_APIKEY
  }
  if (envKey === 'USER_DEV') {
    return process.env.NEXT_PUBLIC_USER_DEV === 'TRUE'
  }
  if (envKey === 'BUILD_ENV') {
    return process.env.NEXT_PUBLIC_BUILD_ENV
  }
  if (envKey === 'PRODUCTION') {
    return process.env.NEXT_PUBLIC_PRODUCTION === 'TRUE'
  }
  if (envKey === 'DEVELOPMENT') {
    return process.env.NEXT_PUBLIC_DEVELOPMENT === 'TRUE'
  }
  if (envKey === 'API_BASE_URL') {
    return process.env.NEXT_PUBLIC_API_BASE_URL
  }
  if (envKey === 'FIREBASE_apiKey') {
    return process.env.NEXT_PUBLIC_FIREBASE_apiKey
  }
  if (envKey === 'FIREBASE_authDomain') {
    return process.env.NEXT_PUBLIC_FIREBASE_authDomain
  }
  if (envKey === 'FIREBASE_databaseURL') {
    return process.env.NEXT_PUBLIC_FIREBASE_databaseURL
  }
  if (envKey === 'FIREBASE_projectId') {
    return process.env.NEXT_PUBLIC_FIREBASE_projectId
  }
  if (envKey === 'FIREBASE_storageBucket') {
    return process.env.NEXT_PUBLIC_FIREBASE_storageBucket
  }
  if (envKey === 'FIREBASE_messagingSenderId') {
    return process.env.NEXT_PUBLIC_FIREBASE_messagingSenderId
  }
  if (envKey === 'FIREBASE_appId') {
    return process.env.NEXT_PUBLIC_FIREBASE_appId
  }
  if (envKey === 'FIREBASE_measurementId') {
    return process.env.NEXT_PUBLIC_FIREBASE_measurementId
  }
  if (envKey === 'FACEBOOK_PIXEL_ID') {
    return process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID
  }
  if (envKey === 'GOOGLE_MAP_API_KEY') {
    return process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY
  }
}

export default getEnv
